export default __webpack_public_path__ + "static/DT_intro_background-ffaf2967266040a2ba34bbb2f3d52bc5.png";